import { Alert } from "@mantine/core";
import { Link } from "react-router";
import { AlertPresets } from "../../../mantine/mantinePresets";
import { ExpressOnboardingModal } from "../ExpressOnboardingModal/ExpressOnboardingModal";
import { useExpressOnboardingModal } from "../ExpressOnboardingModal/hooks/useExpressOnboardingModal";

interface ExpressOnboardingBoxProps {
  siteId: number;
}

function ExpressOnboardingBox({ siteId }: ExpressOnboardingBoxProps) {
  const { isOpen, tab, openSearchParams, setTab, close } =
    useExpressOnboardingModal();
  return (
    <>
      <Alert
        color={AlertPresets.info.color}
        title="Alle Liegenschaften im Blick"
      >
        Prüfen und ergänzen Sie Daten mehrerer Liegenschaften in einer
        gemeinsamen Ansicht.
        <br />
        <br />
        <Link to={{ search: openSearchParams.toString() }}>
          Liegenschaftsübergreifende Ansicht
        </Link>
      </Alert>
      <ExpressOnboardingModal
        opened={isOpen}
        siteId={siteId}
        tab={tab}
        onClose={close}
        onTabChange={setTab}
      />
    </>
  );
}

export { ExpressOnboardingBox };
